import type { ResponsiveImageOutput } from 'contracts';
import parse from 'utils/parse';

import CherryTv from './assets/cherry-tv.jpg';
import CherryTvLogo from './assets/cherry-tv-logo.svg';
import LoyalFans from './assets/loyalfans.jpg';
import LoyalFansLogo from './assets/loyalfans-logo.svg';
import SpankBang from './assets/spankbang.jpg';
import SpankBangLogo from './assets/spankbang-logo.svg';
import SXCom from './assets/sx-com.jpg';
import SXComLogo from './assets/sx-com-logo.svg';
import messages from './not-convinced-banner.i18n';

const makeTestId = (...ids: string[]): string => parse.toTestId('landing', 'not-convinced-banner', ...ids);

const testId = Object.freeze({
  component: makeTestId(),
});

const translation = messages.pages.landing.notConvincedBanner.livejasmin;

const sites = [
  {
    key: 'loyalfans',
    bg: LoyalFans as ResponsiveImageOutput,
    logo: LoyalFansLogo,
    description: translation.fanClubPlatorm,
    link: 'https://www.loyalfans.com/',
  },
  {
    key: 'spankbang',
    bg: SpankBang as ResponsiveImageOutput,
    logo: SpankBangLogo,
    description: translation.adultContentPlatform,
    link: 'https://www.spankbang.com/',
  },
  {
    key: 'cherrytv',
    bg: CherryTv as ResponsiveImageOutput,
    logo: CherryTvLogo,
    description: translation.streamingPlatform,
    link: 'https://cherry.tv/',
  },
  {
    key: 'sxcom',
    bg: SXCom as ResponsiveImageOutput,
    logo: SXComLogo,
    description: translation.discoveryPlatform,
    link: 'https://www.sex.com/',
  },
];

const config = {
  numVisitorsMillions: 20,
  curtainProgress: {
    min: 0,
    mid: 50,
    max: 100,
  },
  tracking: {
    curtainOpened: 'opened',
  },
};

export { testId, sites, config };
